import { Component, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { Keys } from 'app/models/core/dropdowns';
import { ISearchLabs, ISearchLabsParameters } from 'app/models/searchLabs/searchLabs';
import { SettingsService } from 'app/services/core/settings.service';
import { SearchLabsService } from 'app/services/searchLabs/searchLabs.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LabApplicationMenuService } from 'app/services/application-menu/lab-application-menu.service';
import { SharedService } from 'app/services/core/shared.service';
import { IApplicationTechnologyReport, IApplicationTechnologyViewModel } from 'app/models/report/reports';

@Component({
  selector: 'technologyReport',
  templateUrl: './technologyReport.component.html',
  styleUrls: ['./technologyReport.component.scss']
})
export class TechnologyReportComponent {
  @ViewChild('pdf') pdf: PDFExportComponent;
  public datePrinted: string = new Date().toLocaleDateString('en-US');

  public techData: IApplicationTechnologyReport = {
    labName: '',
    orelapId: '',
    labId: 0,
    epaId: '',
    appId: 0,
    technologies: []
  };
  
  public groupedTechnologies: { 
    name: string, 
    instruments: { instrumentTechnology: string, 
      technologies: IApplicationTechnologyViewModel[] }[] }[] = [];

  constructor(public searchLabsService: SearchLabsService,
    public settings: SettingsService,
    private dialogRef: MatDialogRef<TechnologyReportComponent>,
    private labApplicationMenuService: LabApplicationMenuService,
    private sharedService: SharedService
  ) {
    this.labApplicationMenuService.getTechReport(this.sharedService.currentApplication.labId).subscribe(
      response => {
        this.techData = response;
        this.groupTechnologies(response.technologies);
      },
      error => console.log('error', error)
    );
  }

  groupTechnologies(technologies: IApplicationTechnologyViewModel[]): void {
    // First group by name
    const byName: { [key: string]: IApplicationTechnologyViewModel[] } = {};
    technologies.forEach(tech => {
      if (!byName[tech.name]) {
        byName[tech.name] = [];
      }
      byName[tech.name].push(tech);
    });

    // Then group each name by instrumentTechnology
    this.groupedTechnologies = Object.keys(byName).map(name => {
      const techsForName = byName[name];
      const byInstrument: { [key: string]: IApplicationTechnologyViewModel[] } = {};
      
      techsForName.forEach(tech => {
        if (!byInstrument[tech.instrumentTechnology]) {
          byInstrument[tech.instrumentTechnology] = [];
        }
        byInstrument[tech.instrumentTechnology].push(tech);
      });

      return {
        name: name,
        instruments: Object.keys(byInstrument).map(instrument => ({
          instrumentTechnology: instrument,
          technologies: byInstrument[instrument]
        }))
      };
    });
  }

  ngOnInit(): void {
  }

  printReport(): void {
    if (this.pdf) {
      this.pdf.saveAs('ORELAP_Technology_Report.pdf');
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
